export default __webpack_public_path__ + "static/media/logo.7e6ea8dc.svg";